var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.734 0H10.1c-.336 0-.658.125-.896.348-.237.223-.37.526-.37.841v5.353c0 .157.066.309.185.42.119.112.28.174.447.174h1.9a.66.66 0 0 0 .448-.174.58.58 0 0 0 .185-.42V1.189c0-.315-.133-.618-.37-.84A1.3 1.3 0 0 0 10.733 0M7.568 1.556h-.072C6.16 1.21 4.394.595 2.757.595c-.886 0-1.008.313-1.19.782L.077 5.54A1.12 1.12 0 0 0 .228 6.63c.116.157.272.284.452.373.18.088.38.134.584.134H3.77l-.985 2.677c-.032.244.028.492.17.7.141.208.356.362.606.437s.52.065.764-.027c.243-.093.445-.262.57-.48A15 15 0 0 1 7.57 7.257z"
  })));
};
export default SvgDislike;